//@codekit-prepend "jquery.cookie.js"

(function ($) {

	$(document).ready(function () {

		

	});


	$( window ).load( function() {
		
		var d = new Date();
		var currentTime = Math.round(d.getTime()/1000);
		
		//Set global popup timer
		if (typeof $.cookie('jrpGlobalPopupTimer') === 'undefined') {
			$.cookie('jrpGlobalPopupTimer', currentTime, { expires: 365, path: '/' });
		}
		
		$('.jrp-popup').each(function() {

			var popup = new Popup( $(this) );
			popup.init();

			setInterval(() => {
				popup.checkStatus();
			}, 1000);

			$(this).data('jrp-popup', popup);

		});

		$('[data-jrp-popup]').click(function(e) {
			e.preventDefault();
			var id = $(this).data('jrp-popup');
			var $popup = $('#jrp-popup-' + id );

			if ( $popup.length > 0 ) {
				var popup = $popup.data('jrp-popup');
				popup.show();
			}
		});


	});
	
	
	function bakeCookie(name, value) {
	  	$.cookie(name, JSON.stringify(value), { expires: 365, path: '/' });
	}
	
	function readCookie(name) {
	 	return JSON.parse($.cookie(name));
	}


	function Popup( $popup ) {

		this.popup = $popup;
		this.id = $popup.data('id');
		this.displayType = $popup.data('display_type');
		this.activationRules = $popup.data('activation_rules');
		this.timeTillActive = $popup.data('time_till_active');
		this.dismissalExpiryTime = $popup.data('dismissal_expiry_time');
		this.pageCount = $popup.data('page_count');
		this.cookieName = 'jrpPopup' + this.id;
		this.cookieValues = {};
		this.globalTime = readCookie('jrpGlobalPopupTimer');
		this.active = false;
		this.currentTime;
		this.currentPage = $popup.data('current_page');
		this.specificPages = $popup.data('specific_pages');
		this.ignorePages = $popup.data('ignore_pages');
		
		this.init = function() {

			var d = new Date();
			this.currentTime = Math.round(d.getTime()/1000);

			this.loadCookieValues();

			// Close on button click
			this.popup.find('.dismiss').click( (e) => {
				e.preventDefault();
				this.dismiss();
			});

			// close on background click
			this.popup.find('.jrp-popup-bg').on('click', (e) => {
				this.dismiss();
			});

			this.popup.on('click', (e) => {

				if ($(e.target).closest('.jrp-popup-content').length === 0 ) {
					this.dismiss();
				}

			});


		}

		this.loadCookieValues = function() {

			if ( typeof $.cookie( this.cookieName ) === 'undefined' ) {
			
				this.cookieValues = {
					pagesVisited : 0,
					timeCreated : this.currentTime,
					dismissed : false,
					timesDismissed : 0
				};
				
			} else {
				
				var oldCookieValues = readCookie( this.cookieName );
				
				this.cookieValues = {
					pagesVisited : parseInt( oldCookieValues.pagesVisited ) + 1,
					timeCreated : oldCookieValues.timeCreated,
					dismissed : oldCookieValues.dismissed,
					timesDismissed : oldCookieValues.timesDismissed
				};
				
			}

		}

		this.checkStatus = function() {

			var d = new Date();
			this.currentTime = Math.round(d.getTime()/1000);

			// Load cookie values
			this.loadCookieValues();

			// Check expiry time
			this.checkExpiryTime();
			
			if ( this.isActive() ) {

				this.show();
				this.cookieValues.dismissed = this.currentTime;
				this.bakeCookieValues();

			}

		}

		this.isDismissed = function() {
			
			if ( this.cookieValues.dismissed === false ) {
				return false;
			}

			return true;

		}

		this.getTimeElapsed = function() {
			return this.currentTime - this.cookieValues.timeCreated;
		}

		this.getPagesVisited = function() {
			return this.cookieValues.pagesVisited;
		}

		this.isOnPopupPage = function() {

			if ( ! this.specificPages ) {
				return false;
			}
			
			if ( this.specificPages.indexOf( this.currentPage ) === -1 ) {
				return false;
			}

			return true;
		}

		this.isOnIgnorePage = function() {

			if ( ! this.ignorePages ) {
				return false;
			}
			
			if ( this.ignorePages.indexOf( this.currentPage ) === -1 ) {
				return false;
			}

			return true;

		}

		this.hasActivationRule = function( rule ) {

			if ( this.activationRules.indexOf( rule ) !== -1 ) {
				return true;
			}

			return false;
		}

		// Check if the popup should be shown
		this.isActive = function() {

			// If the popup hasn't been dismissed
			if ( ! this.isDismissed() ) {

				if ( this.isOnIgnorePage() ) {
					return false;
				}
							
				var timeElapsed = this.getTimeElapsed();
				var pagesVisited = this.getPagesVisited();

				// If popup shows after time and time has elapsed
				if ( this.hasActivationRule('time') && timeElapsed >= this.timeTillActive ) {
					return true;
				}

				// If popup shows after number of pages and pages exceeds
				if ( this.hasActivationRule('pages') && this.getPagesVisited() > this.pageCount ) {
					return true;
				}

				// If popup is to be shown on specific page
				if ( this.hasActivationRule('page') && this.isOnPopupPage() ) {
					return true;
				}

			}

		}

		// Show the popup
		this.show = function() {

			this.popup.addClass('active');
			$('html').addClass('jrp-popup-active');

		}

		// Dismiss the popup
		this.dismiss = function() {

			this.popup.removeClass('active');
			$('html').removeClass('jrp-popup-active');

			this.cookieValues.dismissed = this.currentTime;
			this.cookieValues.timesDismissed += 1;
			this.bakeCookieValues();

		}

		this.bakeCookieValues = function() {
			bakeCookie( this.cookieName, this.cookieValues);
		}

		this.checkExpiryTime = function() {

			// If dismissed and enough time has elapsed, set dismissed to false
			if ( this.isDismissed !== false && ( this.currentTime - this.cookieValues.dismissed ) >= this.dismissalExpiryTime ) {
				this.cookieValues.dismissed = false;
			}

			this.bakeCookieValues();

		}

	}



})(jQuery);
